import React, { useState } from 'react';
import {
  plantMetadataInLocalStorageAndReturnTransferUrl,
  setPartnerNameAndImageWithId,
  convertProps,
} from 'partial/OfferManager/holder/genericOfferLogic';
import { fetchApplyNowTracking } from 'externals/_services/tracking.service';
import { withRouter } from 'react-router-dom';
import { cleanPopupPaths } from 'helpers/path.helper';
import { getFullAttributes } from 'helpers/tracking.helpers';
import {
  CLICK_APPLY,
  CLICK,
  SEEN_OFFER,
} from 'externals/_tracking/types/eventTypes.constants';
import VisibilitySensor from 'react-visibility-sensor';
import useTrackingMetadata from 'externals/_tracking/useTrackingMetadata';
import {
  goToAutoLoanRefinanceMarketplace,
  getSavingsAmounts,
  getCurrentLoanDetails,
} from 'helpers/autoOffer.helpers';
import { useDispatch, useSelector } from 'react-redux';
import { wrapService } from 'actions/service_wrapper.actions';
import { getMrphPageFormFactor } from 'helpers/metadataLogic.helpers';

const a_fetchApplyNowTracking = wrapService(fetchApplyNowTracking, {
  name: 'auto_fetchApplyNowTracking',
});

const AutoLoanOfferHolder = props => {
  const trackingManager = useTrackingMetadata();
  const { setPagePosition, pageNameMeta } = trackingManager;
  const isModal = props.isModal;
  const [isSeenTriggered, setIsSeenTriggered] = useState(false);
  const defaultEventHandler = (name, attributes = {}) => {
    const fullAttributes = getFullAttributes({
      partner: props.partner,
      pagePosition: props.pagePosition,
      modulePosition: props.modulePosition,
      offerMetadata: props.offerMetadata,
      position: props.position,
      extraAttributes: props.extraAttributes,
      attributes: attributes,
      isModal: isModal,
    });
    props.eventHandler(name, fullAttributes);
  };
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, creditInfo, ocfInfo } = useSelector(state => ({
    userInfo: state.userInfo.userInfo,
    creditInfo: state.creditInfo.creditInfo,
    ocfInfo: state?.ocfInfo?.ocfInfo,
  }));

  let lenderName = props.offerMetadata?.provider?.lenderName;
  let imageLink = props.offerMetadata?.provider?.imageLink;
  let finalClickUrl = props.offerMetadata?.applyLinkUrl;
  let isQueryStringInitialized = true;

  if (props.offerMetadata.isFeaturedAd) {
    lenderName = props.offerMetadata.name;
    imageLink = props.offerMetadata.imageLink;
    finalClickUrl = props.offerMetadata.linkUrl;
    isQueryStringInitialized = false;
  }

  const onMouseClickDetails = e => {
    setPagePosition(props.pagePosition);
    defaultEventHandler(CLICK, {
      'Click Type': 'Show Details',
    });
    const currentPath = props.location.pathname;
    const searchPath = props?.location?.search
      ? `${props.location.search}&loanAmount=${props.offerMetadata.loanAmount}`
      : `?loanAmount=${props.offerMetadata.loanAmount}`;
    const cleanPath = cleanPopupPaths(currentPath);
    const finalUrl = `${cleanPath}/offerDetails/autoLoan/${props.offerMetadata.productKey}${searchPath}`;
    props.history.replace(finalUrl);
  };

  const onApplyClick = e => {
    e.preventDefault();
    if (isLoading) return;
    setIsLoading(true);

    const id = setPartnerNameAndImageWithId(lenderName, imageLink);

    let backendAttributes = {
      'Click Type': 'Apply',
      'Page Name': pageNameMeta,
      'Page Form Factor': getMrphPageFormFactor(),
    };

    const propsForBackend = convertProps(
      getFullAttributes({
        partner: props.partner,
        pagePosition: props.pagePosition,
        modulePosition: props.modulePosition,
        offerMetadata: props.offerMetadata,
        position: props.position,
        extraAttributes: props.extraAttributes,
        attributes: backendAttributes,
        isModal: isModal,
        includeBackendRefCode: true,
      }),
    );

    let windowReference = window.open();
    dispatch(
      a_fetchApplyNowTracking(
        finalClickUrl,
        { props: propsForBackend },
        isQueryStringInitialized,
      ),
    )
      .then(trackingMetadata => {
        defaultEventHandler(CLICK_APPLY, {
          'Click Type': 'Apply',
          'Click ID': trackingMetadata.clickId,
          'Page Form Factor': getMrphPageFormFactor(),
        });
        const transferUrl = plantMetadataInLocalStorageAndReturnTransferUrl(
          trackingMetadata.partnerUrl,
          id,
          false,
          props.isOcfPage,
        );
        windowReference.location = transferUrl;
        setIsLoading(false);
      })
      .catch(err => {
        console.error('A problem happened while Transferring', err);
        setIsLoading(false);
      });
  };

  const onVisibilityChange = isVisible => {
    if (isVisible === true && !isSeenTriggered) {
      defaultEventHandler(SEEN_OFFER, {});
      setIsSeenTriggered(true);
    }
  };

  const goToRefinanceMarketplace = currentAutoLoan => {
    goToAutoLoanRefinanceMarketplace(
      currentAutoLoan,
      userInfo,
      creditInfo,
      defaultEventHandler,
      dispatch,
      props.history,
    );
  };

  const ocfCreditProfile = ocfInfo
    ? ocfInfo?.creditProfile
    : props?.ocfData?.creditProfile;

  const currentLoanDetails = getCurrentLoanDetails(
    props?.isOcfPage ? ocfCreditProfile : creditInfo,
  );

  const savingsAmount = getSavingsAmounts(
    currentLoanDetails,
    props.offerMetadata,
  );

  return (
    <props.autoLoanTemplate
      offerImageLinkUrlProxy={`${imageLink}`}
      clickApplyHandler={onApplyClick}
      clickDetailsHandler={onMouseClickDetails}
      pagePosition={props.pagePosition}
      goToRefinanceMarketplace={goToRefinanceMarketplace}
      currentLoanDetails={currentLoanDetails}
      savingsAmount={savingsAmount}
      seenPixel={
        <VisibilitySensor onChange={onVisibilityChange}>
          <div className="invisible-pixel" />
        </VisibilitySensor>
      }
      {...props}
    />
  );
};

AutoLoanOfferHolder.defaultProps = {
  extraEventAttributes: {},
};

const connectedAutoLoanOfferHolder = withRouter(AutoLoanOfferHolder);

export default connectedAutoLoanOfferHolder;
